export default __webpack_public_path__ + "static/media/downArrowLogo.05b69c94.svg";